import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { mediaUrl, IMG } from '../lib/mediaUrl';
import { useSeo } from '../lib/useSeo';

function money(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}

// Minimal direction (Chase 2026-07-22): the WebGL hero (Lightfall) and the
// Antigravity particle field are gone. The hero is the vault photo he liked
// from the early test build — a still image, a dark scrim, one headline, one
// button. Below it, the arrivals grid shows several cards at once. No
// per-page effects; the only motion left is one whisper-faint cursor glow
// mounted globally, desktop-only.
export default function HomePage() {
  const [featured, setFeatured] = useState([]);
  const [loading, setLoading] = useState(true);

  useSeo({
    title: 'Shiny Vault LGS — Pokemon & TCG Cards, Sealed & Singles',
    description:
      'Your online Pokemon & TCG store. Shop singles, sealed product, Elite Trainer Boxes, graded slabs, Japanese cards, and accessories. Sourced, authenticated, and shipped fast.',
    image: 'https://shinyvaultlgs.com/og-image.jpg',
    url: 'https://shinyvaultlgs.com/',
  });

  useEffect(() => {
    supabase
      .from('products')
      .select('id, name, slug, price_cents, category_id, product_media(storage_path, sort_order)')
      .eq('status', 'active')
      .order('created_at', { ascending: false })
      .limit(8)
      .then(({ data: prods }) => {
        setFeatured(prods || []);
        setLoading(false);
      });
  }, []);

  const coverPhotoUrl = (product) => {
    const photos = (product.product_media || []).slice().sort((a, b) => a.sort_order - b.sort_order);
    if (!photos[0]) return null;
    return mediaUrl(photos[0].storage_path, IMG.card);
  };

  return (
    <div>
      <section className="sv-hero">
        <div
          className="sv-hero-bg"
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/hero-vault.jpg)` }}
          aria-hidden="true"
        />
        <div className="sv-hero-scrim" />
        <div className="sv-hero-content">
          <div className="sv-hero-eyebrow">New arrivals weekly</div>
          <h1 className="sv-hero-title">The vault is open.</h1>
          <p className="sv-hero-sub">
            Graded slabs, sealed product, and vintage singles — sourced, authenticated,
            and shipped from one collection to the next.
          </p>
          <Link to="/shop" className="sv-btn sv-hero-cta" style={{ padding: '14px 30px' }}>
            Enter the shop
          </Link>
        </div>
      </section>

      {!loading && featured.length > 0 && (
        <section className="sv-arrivals">
          <div className="sv-container">
            <div className="sv-section-head">
              <h2>New arrivals</h2>
              <Link to="/shop">Shop all &rarr;</Link>
            </div>
            <div className="sv-product-grid">
              {featured.map((p) => {
                const photoUrl = coverPhotoUrl(p);
                return (
                  <Link key={p.id} to={`/product/${p.slug}`} className="sv-card" style={{ overflow: 'hidden', display: 'block' }}>
                    <div
                      style={{
                        aspectRatio: '3 / 4', background: 'var(--bg-elevated)', display: 'flex',
                        alignItems: 'center', justifyContent: 'center', color: 'var(--text-muted)',
                        padding: 12,
                      }}
                    >
                      {photoUrl && <img src={photoUrl} alt={p.name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />}
                    </div>
                    <div style={{ padding: 14 }}>
                      <div style={{ fontWeight: 700, fontSize: '0.92rem', marginBottom: 4 }}>{p.name}</div>
                      <span style={{ fontWeight: 800 }}>{money(p.price_cents)}</span>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
